import React, { useEffect, useMemo } from 'react';
import type { DealerLocationData } from '../../hooks/useGetDealerDetails';
import useCreateMetaTitle from '../../hooks/useCreateMetaTitle';
import useCreateMetaDescription from '../../hooks/useCreateMetaDescription';
import { Helmet } from 'react-helmet-async';
import { createRobotsTagNoIndex } from '../../utils/createRobotsTagNoIndex';
import type { VehicleInfo } from '../../types';

const MetaDataComponent = ({
  dealerInfo,
  vehicleData,
}: {
  dealerInfo: DealerLocationData | undefined;
  vehicleData: VehicleInfo | undefined;
}) => {
  const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
  const market = new URLSearchParams(locationSearch).get('market') ?? 'ca';
  const vehicleId = new URLSearchParams(locationSearch).has('vehicleId');

  const metaTitle = useCreateMetaTitle(vehicleData, dealerInfo);
  const metaDescription = useCreateMetaDescription(vehicleData, dealerInfo);

  const robotNoIndexTag = useMemo(() => {
    return createRobotsTagNoIndex(!!market, vehicleId);
  }, [market, vehicleId]);

  useEffect(() => {
    let metaDescriptionTag = document.querySelector('meta[name="description"]');

    if (!metaDescriptionTag) {
      metaDescriptionTag = document.createElement('meta');
      metaDescriptionTag.setAttribute('name', 'description');
      document.head.appendChild(metaDescriptionTag);
    }

    metaDescriptionTag.setAttribute('content', metaDescription);
  }, [metaDescription]);

  return (
    <Helmet prioritizeSeoTags>
      <title>{metaTitle}</title>
      {robotNoIndexTag}
    </Helmet>
  );
};

export default MetaDataComponent;
